<a
  [routerLink]="['/artigos', item.slug]"
  [title]="item.title"
  class="card"
  [ngClass]="{ 'lock' : item.is_exclusive }">
  <div
    (click)="stopPropagation($event)"
    class="favorite-icon"
    *ngIf="showFavorite"
  >
    <app-button-favorite [data]="data"> </app-button-favorite>
  </div>

  <figure class="card-figure" [ngClass]="{ 'professionals' : !item.for_patients }">
    <picture>
      <source
        media="(min-width: 1024px)"
        [attr.data-srcset]="item?.images?.desktop"
        *ngIf="lazySwiper"
      />
      <source
        media="(min-width: 1024px)"
        [srcset]="item?.images?.desktop"
        *ngIf="!lazySwiper"
      />

      <source
        media="(min-width: 768px)"
        [attr.data-srcset]="item?.images?.tablet"
        *ngIf="lazySwiper"
      />
      <source
        media="(min-width: 768px)"
        [srcset]="item?.images?.tablet"
        *ngIf="!lazySwiper"
      />

      <img
        [src]="item?.images?.mobile"
        [alt]="item.title"
        width="370"
        height="172"
        [ngClass]="{'swiper-lazy': lazySwiper}"
      />
    </picture>
  </figure>

  <div class="card-content">
    <h4 class="card-title">{{ item.title }}</h4>
    <app-button width="full" mode="outlined" size="md">Saiba mais</app-button>
  </div>

  <div *ngIf="lazySwiper" class="swiper-lazy-preloader"></div>
</a>
